import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

// Premium gold compass emblem + wordmark. `variant` controls color for dark/light backgrounds.
export function Logo({ variant = "light", className = "", showText = true }) {
  const text = variant === "light" ? "text-warm" : "text-navy";
  return (
    <Link to="/" data-testid="logo-home-link" className={`flex items-center gap-3 group ${className}`}>
      <span className="relative flex h-9 w-9 items-center justify-center rounded-full border border-gold/60 bg-gold/10 transition-transform duration-500 group-hover:rotate-45">
        <Compass className="h-5 w-5 text-gold" strokeWidth={1.5} />
      </span>
      {showText && (
        <span className="flex flex-col leading-none">
          <span className={`font-playfair text-lg font-700 tracking-wide ${text}`} style={{ fontWeight: 700 }}>
            Effizent <span className="text-gold">Europe</span>
          </span>
          <span className={`accent-eyebrow mt-1 ${variant === "light" ? "text-warm/50" : "text-navy/50"}`} style={{ fontSize: "0.5rem", letterSpacing: "0.35em" }}>
            Portugal Partner
          </span>
        </span>
      )}
    </Link>
  );
}
